import { render, staticRenderFns } from "./e-learningSubDetail.vue?vue&type=template&id=2b618ba3"
import script from "./e-learningSubDetail.vue?vue&type=script&lang=js"
export * from "./e-learningSubDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports